import moment from "moment";

// Calculate Time difference of connecting flights in flight detail view
export const newCalculateTotalDuration = (
  segments: any[],
  currentIndex: number
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let totalDuration = 0;
  let layoverDurations: string[] = [];

  if (Array.isArray(segments)) {
    segments.slice(0, currentIndex + 1).forEach(({ Flight }, index) => {
      if (Flight && index > 0) {
        const layover = moment(Flight.DepartureTime).diff(
          moment(segments[index - 1].Flight.ArrivalTime)
        );
        totalDuration += layover;

        const individualDuration = TimecalculateTimeDifference(
          segments[index - 1].Flight.ArrivalTime,
          Flight.DepartureTime
        );
        if (index === currentIndex) {
          // Only push the duration for the current segment
          layoverDurations.push(individualDuration);
        }
      }
    });
  }

  let resultString = layoverDurations.join(" ");
  return resultString;
};

const TimecalculateTimeDifference = (
  startTime: string,
  endTime: string
): string => {
  const startMoment = moment(startTime);
  const endMoment = moment(endTime);
  const duration = moment.duration(endMoment.diff(startMoment));
  const hours = Math.floor(duration.asHours());
  const minutes = Math.floor(duration.asMinutes()) % 60;

  return `${hours}h ${minutes}m`;
};
